<div @eqaSlideInTop class="t-dialog-content">
	<ng-container *polymorpheusOutlet="context.content as content; context: context"> </ng-container>
</div>
